import type { SubscriptionPlan, User } from '@repo/domain/user';
import env from '@repo/env';
import { useSubscriptionStore } from '@repo/subscription/client';

import { useUserStore } from '.';

// These are the temporal utilities to handle setting the proper plan field (based on the workspace)
// TODO: Remove this file once by https://app.clickup.com/t/86c2ztc52

const isTestEnv = (): boolean => {
  return env.nodeEnv === 'test' || !!window.Cypress;
};

/**
 * Gets the current plan for the user and applies it to the user object.
 *
 * @param user - The user object to apply the plan to
 * @returns the user object with the plan applied
 */
export const applyUserPlan = <T extends User | null | false>(user: T): T => {
  const subscription = useSubscriptionStore.getState().subscription;

  if (!subscription) {
    // if the subscription isn't loaded yet, don't update the user
    return user;
  }

  const planName = subscription.plan?.name;

  // @ts-expect-error This is a temporary fix to handle the plan field
  const plan = (planName === 'FREE'
    ? undefined
    : planName) as unknown as SubscriptionPlan;

  if (user && !isTestEnv()) {
    return {
      ...user,
      plan: plan,
      user: {
        ...user.user,
        plan: plan,
      },
      profile: {
        ...user.profile,
        plan: plan,
      },
    };
  }
  return user;
};

useSubscriptionStore.subscribe((state, prevState) => {
  const plan = state.subscription?.plan?.name;
  const prevPlan = prevState.subscription?.plan?.name;

  if (plan !== prevPlan && !isTestEnv()) {
    useUserStore.setState((state) => ({
      ...state,
      user: applyUserPlan(state.user),
    }));
  }
});
